import { render, staticRenderFns } from "./fix-header.vue?vue&type=template&id=70786bd4&scoped=true"
import script from "./fix-header.vue?vue&type=script&lang=js"
export * from "./fix-header.vue?vue&type=script&lang=js"
import style0 from "./fix-header.vue?vue&type=style&index=0&id=70786bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70786bd4",
  null
  
)

export default component.exports